export default {
    PLAY: 'play',
    STOP: 'stop',
    END: 'end',
    STOP_PUSHING_LOOTS: 'stop-pushing-loots',
    BEFORE_START: 'before-start',
    FINISHING: 'finishing'
};
